angular.module('olivioConfiguratorApp')
  .controller('GoboCtrl', function ($scope, Model, Data, StepService) {

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;

    $scope.selectGoboOption = function($id) {
      var gobo = Data.getGoboOption($id);
      if (gobo) {
        console.log('selectGoboOption', $id,$scope.model.gobo.id, gobo,  $scope.model);
        if ($scope.model.gobo.id !== $id) {
          $scope.model.gobo.id = $id;

          $scope.model.gobo.individualType = new Array($scope.model.design.lumcount);  //  $scope.model.gobo.individual ist danach eventuell länger als .individualType. derzeit wird nirgends angenommen, dass beide gleich lang sind
          for (var i = 0; i < $scope.model.design.lumcount; i++) {
            if($scope.model.gobo.individual[i])
              $scope.model.gobo.individualType[i] = $id;
          }
        }
        $scope.model.gobo.done = true;
        StepService.nextStep();
      } // TODO else software configuration error
      console.log('selectGoboOption:',$scope.model.gobo.id, $scope.model.gobo.individual, $scope.model.gobo.individualType, Data.goboOptions);
    }
  });
